import { IndicatorAlertSettingsRepository } from "@core/data/repositories/indicator-alert-settings.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { IndicatorAlertSettings } from "@core/domain/models/indicator-alert-settings.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class UpdateMyIndicatorAlertSettingsUseCase {
    constructor(
        @inject(IndicatorAlertSettingsRepository)
        private readonly repository: IndicatorAlertSettingsRepository,
    ) {}

    execute(
        settings: IndicatorAlertSettings,
    ): Promise<Either<FallbackError, IndicatorAlertSettings>> {
        return this.repository.updateMy(settings);
    }
}
